import { SidebarEventLabels } from 'analytics/constants/labels';

import { getLanguage } from 'api/utils/languageManagment';

import { getDeviceOs } from 'helpers/getDeviceOs';
import { getFaqLinks } from 'helpers/getFAQLinks';

import config from 'appConfig';

const lang = getLanguage();
const deviceOs = getDeviceOs();

export const useGetSecondaryLinks = () => [
    {
        to: getFaqLinks(lang, String(deviceOs)),
        title: 'sidebar.faq',
        dataLocator: 'burgerFAQ',
        target: '_blank',
        analyticLabel: SidebarEventLabels.faq,
    },
    {
        to: `${config.links.termsOfUse}?language=${lang}`,
        title: 'sidebar.terms',
        dataLocator: 'burgerTermsOfUse',
        target: '_blank',
        analyticLabel: SidebarEventLabels.terms,
    },
    {
        to: `${config.links.privacyPolicy}?language=${lang}`,
        title: 'sidebar.privacy',
        dataLocator: 'burgerPrivacyPolicy',
        target: '_blank',
        analyticLabel: SidebarEventLabels.privacy,
    },
    {
        to: `${config.links.refundPolicy}?language=${lang}`,
        title: 'sidebar.refund',
        dataLocator: 'burgerRefundPolicy',
        target: '_blank',
        analyticLabel: SidebarEventLabels.refund,
    },
];

export const SIDEBAR_WIDTH = 312;
